import Swiper, {Navigation} from "swiper";
import PerfectScrollbar from "perfect-scrollbar";
import partnerCard from "@partials/partner-cards.handlebars";
import {ToggleScroll} from "./toggle-scroll";


/** Класс создания слайдера с карточками партнера. */
class PartnersCardsSlider {
    documentEl = document.body

    swiper

    swiperWrapper

    content = []

    cards

    scrollbar

    /**
     * Конструктор класса.
     *
     * @param {HTMLElement} el Элемент.
     */
    constructor(el) {
        this.el = el;
        this.elementScrollbar = this.el.querySelector(".js-scrollbar-card");
        
        this.createScrollbar();
        this.enableSlider();
        this.listenEvents();
    }

    /**
     * Прослушиваем клик на каждую карточку партера.
     * 
     * @returns {void}
     */
    listenEvents() {
        document.addEventListener("click", (e) => {
            if (e.target.closest(".js-partner-card") || e.target.classList.contains("js-partner-card")) {
                const card = e.target.closest(".js-partner-card") || e.target.classList.contains("js-partner-card");
                const listCards = card.closest(".js-partners-cards");
                this.cards = [...listCards.getElementsByClassName("js-partner-card")];
                this.showModal(); 

                for (let i = 0; i < this.cards.length; i++) {
                    this.cards[i].dataset.index = i;                
                }  

                const index = card.dataset.index;
                this.content = [];
                this.createContent();                    
                this.updateSliderContent(this.content);
                                    
                this.swiper.init(); 
                this.swiper.update(); 
                this.swiper.navigation.update(); 
                this.swiper.slideTo(index, 0);
                this.elementScrollbar.scrollTop = 0;
            }
        })

        this.swiper.on("slideChangeTransitionStart", () => {
            this.swiper.updateAutoHeight(0);
            this.scrollbar.update();
        });

        this.swiper.on("slideChange", () => {
            this.swiper.updateAutoHeight(0);
            this.scrollbar.update();
            this.elementScrollbar.querySelector(".partner-card__logo").scrollIntoView(true);
        });
    }

    /**
     * Создание стилизованного скроллбара для модального окна.
     * 
     * @returns {void}
     */
    createScrollbar() {
        this.scrollbar = new PerfectScrollbar(this.elementScrollbar, {
            suppressScrollX: true,
            wheelPropagation: false,
            handlers: ["click-rail", "drag-thumb", "keyboard", "wheel", "touch"],
            scrollingThreshold: 100,
        });
    }

    /**
     * Создание контента для карточек партнера в модальном окне.
     * 
     * @returns {void}
     */
    createContent() {
        this.cards.forEach((card) => {
            const logoBackgroundImage = card.querySelector(".js-partner-card-logo").getAttribute("style");
            const indexStartLogoUrl = logoBackgroundImage.indexOf("/");
            const indexEndLogoUrl = logoBackgroundImage.length - 3;
            
            let content = {
                logo: logoBackgroundImage.slice(indexStartLogoUrl, indexEndLogoUrl),
                country: card.querySelector(".js-partner-card-country")?.innerHTML || null,
                name: card.querySelector(".js-partner-card-name").innerHTML,
                text: card.querySelector(".js-partner-card-text").innerHTML,
                document: card.dataset.partnerDocument || null,
                site: card.dataset.partnerSite || null,
                universityWebsite: card.dataset.universityWebsite || null,
            }

            this.content.push(content);           
        });
    } 

    /**
     * Открытие модального окна.
     * 
     * @returns {void}
     */
    showModal = () => {    
        this.el.classList.add("shown");
        ToggleScroll.disable(this.el);
    };

    /**
     * Инициализация слайдера.
     * 
     * @returns {void}
     */
    enableSlider() {
        this.swiper = new Swiper(this.el.querySelector(".js-partner-cards-slider"), {
            modules: [Navigation],
            slidesPerView: 1,
            loop: false,
            touchMoveStopPropagation: true,
            spaceBetween: 16,
            createElements: true,
            uniqueNavElements: false,
            init: false,
            autoHeight: true,
            observer: true,
            observeParents: true,
            observeSlideChildren: true,
            navigation: {
                nextEl: ".js-partners-nav-next",
                prevEl: ".js-partners-nav-prev",
            },
        });

        this.swiperWrapper = this.swiper.el.firstElementChild;
    }

    /**
     * Создание слайдов в модальном окне.
     * 
     * @param {Object} data Данные партнеров
     * @returns {void}
     */
    createCardsForSlider(data) {
        const cardContent = {
            partner: {
                logo: data.logo,
                country: data.country,
                name: data.name,
                description: data.text,
                document: data.document,
                site: data.site,
                universityWebsite: data.universityWebsite,
            }
        }

        const partner = partnerCard(cardContent);

        this.swiperWrapper.insertAdjacentHTML("beforeend", partner);
    }

    /**
     * Обновление контента в слайдерах при открытии модального окна.
     * 
     * @param {Object} data Данные партнеров
     * @returns {void}
     */
    updateSliderContent(data) {
        this.swiperWrapper.innerHTML = "";

        data.forEach((el) => {
            this.createCardsForSlider(el);
        });
    }
}

document
    .querySelectorAll(".js-modal-partners")
    .forEach(slider => new PartnersCardsSlider(slider));
